import { can } from "../General"
import { ClaimMenu } from "./ClaimMenu"
import { isDeveloperMode } from "../../components/developers/developerMode"
import { useInternalCompany } from "../useInternalCompany"
import { sync_get_setting } from "@/components/settings/useTreeSetting"



export const InvoiceFinalizeSent = [
    // {
    //     disabled: false,
    //     loading: false,
    //     icon: "fas fa-cash-register",
    //     emit: "kooi:invoice:menu:paid",
    //     key: "paid",
    //     text: "labels.invoice.menus.set_paid"
    // },
    // {
    //     disabled: false,
    //     loading: false,
    //     icon: "fas fa-handshake-slash",
    //     emit: "kooi:menu:status:open",
    //     key: "open",
    //     text: "labels.invoice.menus.set_open"
    // },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-paper-plane",
        emit: "kooi:offer:menu:send_email",
        key: "sendmail",
        text: "labels.order.send_email",
        function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "c" || item.type == "po")) != undefined) }
    },
    {
        disabled: false,
        loading: false,
        loadingFunction: function (data) { return (data && data.loading_states && data.loading_states.filter(item => item.filter == 'inv').length > 0) },
        icon: "fas fa-clipboard-check",
        emit: "kooi:offer:menu:pdf_validation",
        key: "validatepdf",
        text: "labels.pdf.validation.pdf_validation",
        function: function (data) { return isDeveloperMode.value || (data && data.pdf && data.pdf.find(item => item.type == "inv") == undefined) }
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-file-pdf",
        emit: "kooi:offer:menu:openpdf",
        key: "openpdf",
        text: 'labels.order.download_pdf',
        function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "inv") != undefined) }
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-file-signature",
        emit: "kooi:menu:openpdf",
        text: 'labels.order.download_inv_pdf',
        data: {
            type  : "inv",
        },
        display: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "inv")) != undefined) },
        function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "inv")) != undefined) }
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-file-powerpoint",
        emit: "kooi:menu:openpdf",
        text: 'labels.order.download_po_pdf',
        data: {
            type  : "po",
        },
        display: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) },
        function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) }
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-paper-plane",
        emit: "kooi:offer:menu:send_email",
        key: "sendmail",
        text: "Send via E-Mail",
        function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "inv") != undefined) }
    },
    {
        loading: false,
        key: "cancellation",
        text: "labels.invoice.menus.cancellation",
        function: function (data) { return can("OOI.cancel") && (data && data.canceled_by == null && data.paid_date == null); }
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-exchange-alt",
        emit: "kooi:invoice:menu:credit_note",
        key: "credit_note",
        text: "labels.invoice.menus.create_credit_note",
        function: function () { return can("OOI.createCreditNote"); }
    },
            {
            disabled: false,
            loading: false,
            key: "proforma_to_real",
            text: "labels.invoice.proforma_to_real",
            display: function (data) {
                const { id } = useInternalCompany();
                const allow_unpaid = sync_get_setting("company." + id.value + "#modules.invoices.unpaid_proforma_to_real");
                 return data.type == "proforma" && data.count_running == "true" && allow_unpaid == true },
            function: function (data) {
                const { id } = useInternalCompany();
                const allow_unpaid = sync_get_setting("company." + id.value + "#modules.invoices.unpaid_proforma_to_real");
                return data.type == "proforma" && data.count_running == "true" && ( allow_unpaid == true || (data.paid_date != null && data.is_fully_paid == true) )
            }
        },
    {
        disabled: false,
        loading: false,
        key: "copy",
        text: "labels.offer.menus.copy"
    },
    {
        disabled: false,
        loading: false,
        key: "emit",
        icon: "fas fa-funnel-dollar",
        emit: "kooi:menu:order:customs_invoice",
        text: "labels.customs_invoice.create",
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-clone",
        emit: "kooi:menu:copy_to_new_kooi",
        key: "emit",
        text: "labels.clone.copy_to_new_kooi"
    },
    ClaimMenu
]

export const InvoiceMenus = {
    outgoing: [
        {
            loading: false,
            key: "sendNow",
            text: "labels.invoice.menus.send_mail"
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-paper-plane",
            emit: "kooi:offer:menu:send_email",
            key: "sendmail",
            text: "labels.order.send_email",
            function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "c" || item.type == "po")) != undefined) }
        },
        {
            loading: false,
            key: "abort",
            text: "labels.invoice.menus.abort",
            icon: "fas fa-plane-slash",
            emit: "kooi:mails:menu:abort",
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "inv") != undefined) }

        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-pdf",
            emit: "kooi:offer:menu:openpdf",
            key: "openpdf",
            text: 'labels.order.download_pdf',
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "inv") != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-signature",
            emit: "kooi:menu:openpdf",
            text: 'labels.order.download_inv_pdf',
            data: {
                type  : "inv",
            },
            display: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "inv")) != undefined) },
            function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "inv")) != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-powerpoint",
            emit: "kooi:menu:openpdf",
            text: 'labels.order.download_po_pdf',
            data: {
                type  : "po",
            },
            display: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) },
            function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon_url: "/images/logos/mycroft-mc.png",
            emit: "kooi:menu:finalize",
            key: "finalize",
            text: "labels.order.finalize",
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "inv") != undefined) }
        },
        // {
        //     disabled: false,
        //     loading: false,
        //     icon: "fas fa-cash-register",
        //     emit: "kooi:invoice:menu:paid",
        //     key: "paid",
        //     text: "labels.invoice.menus.set_paid"
        // },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-exchange-alt",
            emit: "kooi:invoice:menu:credit_note",
            key: "credit_note",
            text: "labels.invoice.menus.create_credit_note",
            function: function () { return can("OOI.createCreditNote"); }
        },
        {
            disabled: false,
            loading: false,
            key: "copy",
            text: "labels.offer.menus.copy"
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-exchange-alt",
            emit: "kooi:invoice:menu:credit_note",
            key: "credit_note",
            text: "labels.invoice.menus.create_credit_note",
            function: function () { return can("OOI.createCreditNote"); }
        },
            {
            disabled: false,
            loading: false,
            key: "proforma_to_real",
            text: "labels.invoice.proforma_to_real",
            display: function (data) {
                const { id } = useInternalCompany();
                const allow_unpaid = sync_get_setting("company." + id.value + "#modules.invoices.unpaid_proforma_to_real");
                 return data.type == "proforma" && data.count_running == "true" && allow_unpaid == true },
            function: function (data) {
                const { id } = useInternalCompany();
                const allow_unpaid = sync_get_setting("company." + id.value + "#modules.invoices.unpaid_proforma_to_real");
                return data.type == "proforma" && data.count_running == "true" && ( allow_unpaid == true || (data.paid_date != null && data.is_fully_paid == true) )
            }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-clone",
            emit: "kooi:menu:copy_to_new_kooi",
            key: "emit",
            text: "labels.clone.copy_to_new_kooi"
        },
        ClaimMenu,
    ],
    open: [
        {
            disabled: false,
            loading: false,
            loadingFunction: function (data) { return (data && data.loading_states && data.loading_states.filter(item => item.filter == 'inv').length > 0) },
            icon: "fas fa-clipboard-check",
            emit: "kooi:offer:menu:pdf_validation",
            key: "validatepdf",
            text: "labels.pdf.validation.pdf_validation",
            // function: function (data) { return (!data || !data.pdf || data.pdf.find(item => item.type == "inv") == undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-times",
            emit: "kooi:offer:menu:reject",
            key: "reject",
            text: "labels.offer.menus.reject"
        },
        {
            disabled: false,
            loading: false,
            icon_url: "/images/logos/mycroft-mc.png",
            emit: "kooi:menu:finalize",
            key: "finalize",
            text: "labels.order.finalize",
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "inv" || item.type == "customs") != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-pdf",
            emit: "kooi:offer:menu:openpdf",
            key: "openpdf",
            text: 'labels.order.download_pdf',
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "inv" || item.type == "customs") != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-signature",
            emit: "kooi:menu:openpdf",
            text: 'labels.order.download_inv_pdf',
            data: {
                type  : "inv",
            },
            display: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "inv")) != undefined) },
            function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "inv")) != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-shopping-cart",
            emit: "kooi:order:menu:create_purchase",
            key: "emit",
            text: "labels.pdf.validation.create_purchase",
            display: function () { const { id } = useInternalCompany(); return (id.value == 4); },
            function: function () { const { id } = useInternalCompany(); return (id.value == 4); },
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-powerpoint",
            emit: "kooi:menu:openpdf",
            text: 'labels.order.download_po_pdf',
            data: {
                type  : "po",
            },
            display: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) },
            function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-paper-plane",
            emit: "kooi:offer:menu:send_email",
            key: "sendmail",
            text: "labels.order.send_email",
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "inv" || item.type == "customs") != undefined) }
        },
        {
            disabled: false,
            loading: false,
            key: "copy",
            text: "labels.offer.menus.copy"
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-exchange-alt",
            emit: "kooi:invoice:menu:credit_note",
            key: "credit_note",
            text: "labels.invoice.menus.create_credit_note",
            function: function ( ) { return can("OOI.createCreditNote"); }
        },
        {
            disabled: false,
            loading: false,
            key: "proforma_to_real",
            text: "labels.invoice.proforma_to_real",
            display: function (data) {
                const { id } = useInternalCompany();
                const allow_unpaid = sync_get_setting("company." + id.value + "#modules.invoices.unpaid_proforma_to_real");
                 return data.type == "proforma" && data.count_running == "true" && allow_unpaid == true },
            function: function (data) {
                const { id } = useInternalCompany();
                const allow_unpaid = sync_get_setting("company." + id.value + "#modules.invoices.unpaid_proforma_to_real");
                return data.type == "proforma" && data.count_running == "true" && ( allow_unpaid == true || (data.paid_date != null && data.is_fully_paid == true) )
            }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-clone",
            emit: "kooi:menu:copy_to_new_kooi",
            key: "emit",
            text: "labels.clone.copy_to_new_kooi"
        },
        ClaimMenu,
    ],
    finalize:InvoiceFinalizeSent,
    sent:InvoiceFinalizeSent,
    paid: [
        // {key: "sendOffer", text : "labels.order.send_email"},
        // {
        //     disabled: false,
        //     loading: false,
        //     icon: "fas fa-handshake-slash",
        //     emit: "kooi:menu:status:open",
        //     key: "open",
        //     text: "labels.invoice.menus.set_open"
        // },
        {
            disabled: false,
            loading: false,
            loadingFunction: function (data) { return (data && data.loading_states && data.loading_states.filter(item => item.filter == 'inv').length > 0) },
            icon: "fas fa-clipboard-check",
            emit: "kooi:offer:menu:pdf_validation",
            key: "validatepdf",
            text: "labels.pdf.validation.pdf_validation",
            function: function (data) { return (!data || !data.pdf || data.pdf.length == 0 || data.pdf.filter(item => item.type == "inv" && item && 'mycroft' in item.is_transfered_to).length == 0) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-pdf",
            emit: "kooi:offer:menu:openpdf",
            key: "openpdf",
            text: 'labels.order.download_pdf',
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "inv") != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-signature",
            emit: "kooi:menu:openpdf",
            text: 'labels.order.download_inv_pdf',
            data: {
                type  : "inv",
            },
            display: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "inv")) != undefined) },
            function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "inv")) != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-powerpoint",
            emit: "kooi:menu:openpdf",
            text: 'labels.order.download_po_pdf',
            data: {
                type  : "po",
            },
            display: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) },
            function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-paper-plane",
            emit: "kooi:offer:menu:send_email",
            key: "sendmail",
            text: "Send via E-Mail",
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "inv") != undefined) }
        },
        {
            disabled: false,
            loading: false,
            key: "copy",
            text: "labels.offer.menus.copy"
        },
        {
            disabled: false,
            loading: false,
            icon_url: "/images/logos/mycroft-mc.png",
            emit: "kooi:menu:finalize",
            key: "finalize",
            text: "labels.order.finalize",
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "inv") != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-exchange-alt",
            emit: "kooi:invoice:menu:credit_note",
            key: "credit_note",
            text: "labels.invoice.menus.create_credit_note",
            function: function () { return can("OOI.createCreditNote"); }
        },
        {
            disabled: false,
            loading: false,
            key: "emit",
            icon: "fas fa-funnel-dollar",
            emit: "kooi:menu:order:customs_invoice",
            text: "labels.customs_invoice.create",
        },
        {
            disabled: false,
            loading: false,
            key: "proforma_to_real",
            text: "labels.invoice.proforma_to_real",
            display: function (data) { return data.type == "proforma" && data.count_running == "true" },
            function: function (data) { return data.type == "proforma" && data.count_running == "true" && data.paid_date != null && data.is_fully_paid == true }
        },
        // {key : "cancel", text : "Cancel Invoice"},
        {
            disabled: false,
            loading: false,
            icon: "fas fa-clone",
            emit: "kooi:menu:copy_to_new_kooi",
            key: "emit",
            text: "labels.clone.copy_to_new_kooi"
        },
        ClaimMenu,
    ],
    rejected: [
        {
            disabled: false,
            loading: false,
            icon: "fas fa-handshake-slash",
            emit: "kooi:menu:status:open",
            key: "open",
            text: "labels.invoice.menus.set_open"
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-pdf",
            emit: "kooi:offer:menu:openpdf",
            key: "openpdf",
            text: 'labels.order.download_pdf',
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "inv") != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-signature",
            emit: "kooi:menu:openpdf",
            text: 'labels.order.download_inv_pdf',
            data: {
                type  : "inv",
            },
            display: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "inv")) != undefined) },
            function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "inv")) != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-powerpoint",
            emit: "kooi:menu:openpdf",
            text: 'labels.order.download_po_pdf',
            data: {
                type  : "po",
            },
            display: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) },
            function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-exchange-alt",
            emit: "kooi:invoice:menu:credit_note",
            key: "credit_note",
            text: "labels.invoice.menus.create_credit_note",
            function: function () { return can("OOI.createCreditNote"); }
        },
        {
            disabled: false,
            loading: false,
            key: "copy",
            text: "labels.offer.menus.copy"
        },
        // {
        //     disabled: false,
        //     loading: false,
        //     key: "proforma_to_real",
        //     text: "labels.invoice.proforma_to_real",
        //     function: function (data) { return data.type == "proforma" && data.count_running == "true" }
        // },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-clone",
            emit: "kooi:menu:copy_to_new_kooi",
            key: "emit",
            text: "labels.clone.copy_to_new_kooi"
        },
        ClaimMenu,
    ]
};
